import { PercentageOutlined } from "@ant-design/icons";
import { Col, Form, Row, Typography } from "antd";
import { MazakaDatePicker } from "apps/Common/MazakaDatePicker";
import { MazakaForm } from "apps/Common/MazakaForm";
import { MazakaTextArea } from "apps/Common/MazakaTextarea";
import useMazakaForm from "hooks/useMazakaForm";
import { useSearchParams } from "react-router-dom";
import { sendMLSRequest } from "../MLSPortFolio/Services";
import { FC,  useEffect,  useState } from "react";
import PortFolioUsers from "./PortfolioUsers";
import { MazakaButton } from "apps/Common/MazakaButton";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import dayjs from "dayjs";
import MazakaInputNumber from "apps/Common/MazakaInputNumber";

const AddMLSRequest: FC<{ onFinish: any; selectedStore: any }> = ({
  onFinish,
  selectedStore,
}) => {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const { Text } = Typography;
  const advertId = searchParams.get("id");
  const { formActions, mazakaForm } = useMazakaForm(form);
  


  const handleOnFinish = async () => {
    if(selectedRowKeys?.length<=0)
    {
      mazakaForm.setFailed(2000,"Kullanıcı Seçimi Zorunlu")
      return false
    }
    mazakaForm.setLoading();
    let formValues = form.getFieldsValue();
    formValues["advertId"] = advertId;
    formValues["ppsRequestItems"] = selectedRowKeys.map((userId)=>{
      return {
        storeId:selectedStore?.id,
        portfoyUserId:userId
      }
    })
   
    try {
      await sendMLSRequest(formValues);
      mazakaForm.setSuccess(2000,()=>"İşlem Başarılı")
      openNotificationWithIcon("default","İşlem Başarılı")
      setSelectedRowKeys([])
      form.resetFields()
      onFinish();
    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
    }
  };
  return (
    <>
      <MazakaForm
        form={form}
        onFinish={handleOnFinish}
        submitButtonVisible={false}
        {...formActions}
        initialValues={{ expiryDate: dayjs().subtract(7, "day") }}
      >
        <Row gutter={[20, 20]}>
          <Col xs={24} className="!flex justify-center">
            <Text className="!text-2xl">PPS Bilgileri</Text>
          </Col>
          <MazakaInputNumber
          formattedInputNumber={false}
            name={"commissionRate"}
            label="Komisyon Oranı"
            placeholder="Komisyon Oranı"
            xs={24}
            md={12}
            prefix={<PercentageOutlined />}
            type="number"
            min={0}
            rules={[{ required: true, message: "" }]}
          />
          <MazakaDatePicker
            name={"expiryDate"}
            label="Belıirtilen Tarihe Kadar Paylaş "
            xs={24}
            md={12}
            rules={[{ required: true, message: "" }]}
            

          />

          <MazakaTextArea
            xs={24}
            label="Açıklama"
            placeholder="Açıklama"
            name="Description"
          />

          <Col xs={24} className="!mt-4">
            <Row gutter={[0, 20]}>
              <Col xs={24} className="!flex justify-center">
                <Text className="!text-2xl !font-bold !text-black">{`${selectedStore?.storeName} Danışmanları`}</Text>
              </Col>
              <Col xs={24}>
                <PortFolioUsers
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                  data={selectedStore}
                />
              </Col>
            </Row>
          </Col>

          <Col xs={24}>
            <MazakaButton
              className="!p-4 !bg-[#FFC502] !text-black"
              htmlType="submit"
              processType={formActions.submitProcessType}
            >
              İlanı Paylaşma İsteği Gönder
            </MazakaButton>
          </Col>
        </Row>
      </MazakaForm>
    </>
  );
};

export default AddMLSRequest;
